// 字体与排版配置
export const typographyTokens = {
  // 字体族
  fontFamily: "'Inter', 'HarmonyOS Sans', 'Helvetica Neue', 'sans-serif'",

  // 字体大小
  fontSize: 14, // 基准字号

  // 标题字体大小
  fontSizeLG: 16, // 大型文本
  fontSizeXL: 18, // 模块标题
  fontSizeHeading1: 20, // 页面标题
  fontSizeHeading2: 18, // 次级标题
  fontSizeHeading3: 16, // 小标题
  fontSizeHeading4: 14, // 正文标题
  fontSizeHeading5: 13, // 小型标题

  // 辅助文字
  fontSizeSM: 13, // 小号文本
  fontSizeXS: 12, // 超小号文本

  // 行高
  lineHeight: 1.5715, // 标准行高
  lineHeightLG: 1.6, // 宽松行高
  lineHeightSM: 1.4, // 紧凑行高

  // 字重
  fontWeightNormal: 400, // 常规字重
  fontWeightMedium: 500, // 中等字重
  fontWeightStrong: 600, // 加粗字重
}
